import { Injectable } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { LoggingService } from './logging.service';

@Injectable({
  providedIn: 'root',
})
export class ImageService {
  public constructor(
    private domSanitizer: DomSanitizer,
    private readonly loggingService: LoggingService,
  ) {}

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public getImageBlobUrl(blob: any): SafeUrl {
    if (!blob) {
      this.loggingService.Warning('Image could not be loaded');
      return null;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const urlCreator = window.URL || (window as any).webkitURL;
    return this.domSanitizer.bypassSecurityTrustUrl(urlCreator.createObjectURL(blob));
  }
}
